import { Component, OnInit,Directive, HostListener,ViewChild } from '@angular/core';
@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent {
  pdfSrc = "https://perfectlearningapp.azurewebsites.net//UploadFiles/History_Post_Mauryan_Period_The_Gupta_Dynasty_Study_Unit_1_ENG_Perfect_Learning_Screen_Requirements.pdf";
  pdfSrc1 = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  zoom_scale:number=0.5;
  Rotate:number=0;
  zoom(key:Number):void{
    let zoom:Number=0;
    if(key == 1){zoom=Number(this.zoom_scale)+Number(0.1);}
    if(key == 0){zoom=Number(this.zoom_scale)-Number(0.1);}
    if(zoom>0 || zoom <1.5){
      this.zoom_scale=Number(zoom);
    }
  }
  Rotation(){
    if(Number(this.Rotate)==0){
      this.Rotate =90;   }
    else if(Number(this.Rotate)==90){
        this.Rotate =180;   }
     else if(Number(this.Rotate)==180){
          this.Rotate =0;   } 
  }
}


